import { useContext } from 'react';
import { Link } from 'react-router-dom';
import { Category } from '../../../types/catalog';
import { CategoriesContext } from '../../../App';
import Portal from '../../elements/portal';
import MenuItem, { MenuItemRenderProps } from '../../menu-item';

const menuSelector = 'a[href="/products/catalog/"].mobile-menu-level-item__link + .mobile-menu-catalog';
const menuRoot = document.querySelector('.header > .mobile-menu');
const menu = document.querySelector(menuSelector);
const closeMenu = () => {
    menuRoot?.classList.remove('mobile-menu--opened');
    const body = document.body;
    body.classList.remove('body--noscroll');
    body.style.paddingRight = '0';
    document.querySelector('html')?.classList.remove('overflow-hidden');
    body.scrollTop = 0;
    window.scrollTo(0, 0);
};
const MenuLevelRender = ({ onOpen, name, isOpen, children, slug, url }: MenuItemRenderProps) => (
    <ul className="mobile-menu-catalog-level">
        <li className="mobile-menu-catalog-level-item">
            <span onClick={onOpen} className="mobile-menu-catalog-level-item__link">
                {name}
            </span>
            <i className="fas fa-chevron-right" />
            <div className={'mobile-menu-catalog' + (isOpen ? ' mobile-menu-catalog--opened' : '')}>
                <div className="mobile-menu-catalog__back" onClick={onOpen}>
                    <i className="fas fa-chevron-left" /> Назад
                </div>
                <Link to={url} onClick={closeMenu} className="mobile-menu-catalog-level__category">
                    {name}
                </Link>
                {isOpen && children?.map((c) => <MenuLevel key={slug} {...c} />)}
            </div>
        </li>
    </ul>
);

const MenuLevel = (cat: Category) => {
    return <MenuItem render={MenuLevelRender} {...cat} />;
};

function NewIekMobileMenu() {
    const { categories } = useContext(CategoriesContext);
    const onBack = () => {
        menu?.classList.remove('mobile-menu-catalog--opened');
    };
    return (
        <Portal rootSelector={menuSelector}>
            <div className="mobile-menu-catalog__back" onClick={onBack}>
                <i className="fas fa-chevron-left" /> Назад
            </div>
            <Link to="/" onClick={closeMenu} className="mobile-menu-catalog-level__category">
                Продукция
            </Link>
            {categories.map((c) => (
                <MenuLevel key={c.slug} {...c} />
            ))}
        </Portal>
    );
}

export default NewIekMobileMenu;
